import { render, staticRenderFns } from "./newindex.vue?vue&type=template&id=a669ceac"
import script from "./newindex.vue?vue&type=script&lang=js"
export * from "./newindex.vue?vue&type=script&lang=js"
import style0 from "./newindex.vue?vue&type=style&index=0&id=a669ceac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports